import React from "react";

type Props = {
    option: boolean
}

export const Option: React.FunctionComponent<Props> = ({option}) => {
    if (option) {
        return (<span className="align-top px-2 ml-4 text-sm border border-primary-300 text-primary-600 rounded">オプション</span>)
    }
    return null
}